import { useEffect, useState } from "react";


/**
 * Hook to access local storage
 */
const useLocalStorage = (key: string) => {

    const [value, setValue] = useState<string | null> (() => 
        localStorage.getItem(key) 
    );
    
    // update localStorage whenerver value changes
    useEffect(() => {
        if (value) {
            localStorage.setItem(key, value);
        } else {
            try {
                localStorage.removeItem(key);
            } catch (error) {
                console.error(`Error while removing ${key} entry from local storage`, error) ;
            };
        }
    }, [key, value]);

    // use as const to tell TypeScript this is a tuple
    return [value, setValue] as const;
};


export default useLocalStorage;
